import { __assign } from "tslib";
import { ProductTypeHelper, SearchMaskGroupType, SearchMaskInputType, store, websiteActions } from "ltur-state-engine";
import Vue from "vue-ltur";
var BaseSearchMaskHelper = /** @class */ (function () {
    function BaseSearchMaskHelper() {
    }
    BaseSearchMaskHelper.mapStateToFilter = function (filter, searchMaskGroupType) {
        if (searchMaskGroupType === void 0) { searchMaskGroupType = SearchMaskGroupType.PACKAGE; }
        var lturState = store.getState();
        if (!this.coreMap[filter.identifier]) {
            console.error("no mapping for filter: [ ".concat(filter.identifier, " ]"));
            return;
        }
        var searchMaskGroup = lturState.websiteState.searchMask.searchMaskBundle.groups[searchMaskGroupType];
        var searchMaskInput = searchMaskGroup.inputs[this.coreMap[filter.identifier].inputType];
        if (searchMaskInput.confirmedValue) {
            filter.setFilter(this.coreMap[filter.identifier].mapFromState(filter, searchMaskInput));
        }
    };
    BaseSearchMaskHelper.mapFilterToState = function (filter) {
        if (!this.coreMap[filter.identifier]) {
            console.error("no mapping for filter: [ ".concat(filter.identifier, " ]"));
            return;
        }
        var lturState = store.getState();
        var searchMaskGroupType = ProductTypeHelper.mapToSearchMaskGroupType(lturState.websiteState.searchMask.searchMaskActiveTab);
        var searchMaskGroup = lturState.websiteState.searchMask.searchMaskBundle.groups[searchMaskGroupType];
        var searchMaskInput = searchMaskGroup.inputs[this.coreMap[filter.identifier].inputType];
        searchMaskInput.confirmedValue.value = this.coreMap[filter.identifier].mapToState(filter, searchMaskInput);
        var searchMaskRequest = {
            searchMaskGroupType: searchMaskGroupType,
            searchMaskInput: searchMaskInput,
            inputValueParam: searchMaskInput.confirmedValue
        };
        Vue.dispatch(websiteActions.setSearchMaskConfirmed(searchMaskRequest, lturState));
    };
    BaseSearchMaskHelper.coreMap = {
        travellersFilter: {
            inputType: SearchMaskInputType.TRAVELLERS,
            mapToState: function (filter, input) {
                return __assign(__assign({}, input.confirmedValue.value), { adults: filter.model.adults, ageOfChildren: filter.model.children, ageOfChildrenLength: filter.model.children.length });
            },
            mapFromState: function (filter, input) {
                return {
                    adults: input.confirmedValue.value.adults,
                    children: input.confirmedValue.value.ageOfChildren,
                };
            },
        },
        datePickerFilter: {
            inputType: SearchMaskInputType.TRAVEL_PERIOD,
            mapToState: function (filter, input) {
                return __assign(__assign({}, input.confirmedValue.value), { duration: filter.model.period, exactDuration: !filter.model.flexible, returnDate: filter.model.end, departureDate: filter.model.start });
            },
            mapFromState: function (filter, input) {
                return {
                    period: input.confirmedValue.value.duration,
                    flexible: !input.confirmedValue.value.exactDuration,
                    end: input.confirmedValue.value.returnDate,
                    start: input.confirmedValue.value.departureDate,
                };
            },
        },
        departureAirportFilter: {
            inputType: SearchMaskInputType.DEPARTURE_AIRPORT,
            mapToState: function (filter, input) { return filter.model ? filter.model : input.defaultValue.value; },
            mapFromState: function (filter, input) { return input.confirmedValue.value; },
        },
        destinationFilter: {
            inputType: SearchMaskInputType.DESTINATION,
            mapToState: function (filter, input) {
                var _a;
                if (((_a = filter.model) === null || _a === void 0 ? void 0 : _a.type) === "HOTEL") {
                    var lturState = store.getState();
                    var searchMaskGroupType = ProductTypeHelper.mapToSearchMaskGroupType(lturState.websiteState.searchMask.searchMaskActiveTab);
                    var searchMaskGroup = lturState.websiteState.searchMask.searchMaskBundle.groups[searchMaskGroupType];
                    var searchMaskInput = searchMaskGroup.inputs[SearchMaskInputType.HOTEL_CATEGORY];
                    searchMaskInput.confirmedValue.value = null;
                    delete searchMaskInput.coreQuery.HOTEL_CATEGORY;
                }
                return filter.model ? filter.model : input.defaultValue.value;
            },
            mapFromState: function (filter, input) { return input.confirmedValue.value; },
        },
        priceFilter: {
            inputType: SearchMaskInputType.PRICE_RANGE,
            mapToState: function (filter, input) {
                return __assign(__assign({}, input.defaultValue.value), { priceMin: filter.model[0] === 0 ? null : filter.model[0], priceMax: filter.model[1] === 6000 ? null : filter.model[1] });
            },
            mapFromState: function (filter, input) { return [input.confirmedValue.value.priceMin === null ? 0 : input.confirmedValue.value.priceMin, input.confirmedValue.value.priceMax === null ? 6000 : input.confirmedValue.value.priceMax]; },
        },
        hotelCategoryFilter: {
            inputType: SearchMaskInputType.HOTEL_CATEGORY,
            mapToState: function (filter, input) {
                var mapping = new Map([
                    [1201, null],
                    [1202, 3],
                    [1203, 4],
                    [1204, 5],
                ]);
                return mapping.get(filter.model);
            },
            mapFromState: function (filter, input) {
                var mapping = new Map([
                    [null, 1201],
                    [3, 1202],
                    [4, 1203],
                    [5, 1204],
                ]);
                return mapping.get(input.confirmedValue.value);
            },
        },
        hotelBoardCodesFilter: {
            inputType: SearchMaskInputType.HOTEL_BOARD_CODES,
            mapToState: function (filter, input) { return filter.model === filter.initialValue ? null : filter.model; },
            mapFromState: function (filter, input) { return input.confirmedValue.value === null ? 1401 : input.confirmedValue.value; },
        },
        transferFilter: {
            inputType: SearchMaskInputType.TRANSFER,
            mapToState: function (filter, input) { return filter.model; },
            mapFromState: function (filter, input) { return input.confirmedValue.value; },
        },
    };
    return BaseSearchMaskHelper;
}());
export { BaseSearchMaskHelper };
